import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import AuthContext from "../contexts/AuthContext";
import ToastContext from "../contexts/ToastContext";
import "./Auth.css";
import backgroundImage from "../assets/imagem-prefeitura.jpg";
import { FaEnvelope, FaLock, FaSignInAlt } from "react-icons/fa";
import VerificationNoticeModal from "../components/VerificationNoticeModal";

function Login() {
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const { addToast } = useContext(ToastContext);
  const { setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendHelperText, setResendHelperText] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const normalizedLogin = login.includes("@") ? login : login.replace(/\D/g, "");
      const { data } = await api.post("/auth/login", { login: normalizedLogin, senha });
      localStorage.setItem("token", data.token);
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
      const userResponse = await api.get("/auth/me");
      setUser(userResponse.data);
      addToast("Login realizado com sucesso!", "success");
      navigate("/editais");
    } catch (error) {
      const code = error.response?.data?.code;
      const message = error.response?.data?.message || "Erro ao fazer login.";
      addToast(message, "error");

      if (code === "EMAIL_VERIFICACAO_PENDENTE" || code === "EMAIL_VERIFICACAO_RENOVADO") {
        setShowVerificationModal(true);
      }
    }
  };

  return (
    <div
      className="auth-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <VerificationNoticeModal
        isOpen={showVerificationModal}
        onClose={() => {
          setShowVerificationModal(false);
          setResendDisabled(false);
          setResendHelperText("");
        }}
        onResend={async () => {
          const trimmed = (login || "").trim();
          if (!trimmed) {
            addToast("Informe seu email ou CPF para reenviar.", "error");
            return;
          }

          try {
            setResendDisabled(true);
            setResendHelperText("Solicitando reenvio...");
            await api.post("/auth/resend-verification", { login: trimmed });
            addToast("Email reenviado com sucesso!", "success");
            setResendHelperText(
              "Reenvio solicitado. Aguarde 10 minutos para tentar novamente."
            );
            setTimeout(() => {
              setResendDisabled(false);
              setResendHelperText("");
            }, 10 * 60 * 1000);
          } catch (error) {
            const apiMessage =
              error.response?.data?.message || "Não foi possível reenviar o email.";
            addToast(apiMessage, "error");

            const retryAfter = Number(error.response?.data?.retryAfterSeconds || 0);
            if (retryAfter > 0) {
              setResendHelperText(
                `Aguarde ${Math.ceil(retryAfter / 60)} minuto(s) para tentar novamente.`
              );
              setTimeout(() => {
                setResendDisabled(false);
              }, retryAfter * 1000);
              return;
            }

            setResendDisabled(false);
            setResendHelperText("");
          }
        }}
        resendDisabled={resendDisabled}
        resendHelperText={resendHelperText}
      />
      <div className="auth-card">
        <h1>Login</h1>
        <form onSubmit={handleSubmit} className="form-modern">
          <div className="form-group">
            <label htmlFor="login">Email ou CPF</label>
            <div>
              <FaEnvelope />
              <input
                id="login"
                type="text"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
                placeholder="Digite seu email ou CPF"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <div>
              <FaLock />
              <input
                id="senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                placeholder="Digite sua senha"
              />
            </div>
          </div>
          <div className="form-actions full-width">
            <button type="submit" className="btn-modern">
              <FaSignInAlt />
              <span>Entrar</span>
            </button>
          </div>
          <div className="auth-links">
            <p>
              <Link to="/forgot-password">Esqueceu a senha?</Link>
            </p>
            <p>
              Não tem uma conta? <Link to="/cadastro">Cadastre-se</Link>
            </p>
            <small>
              Precisa de ajuda? <Link to="/faq">Acesse o FAQ</Link>
            </small>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
